import styled from "styled-components";
import { Button } from "../../../styles/components/Buttons.styled";

export const OuterPopup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 2%;

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1001;
  font-size: 20px;
  @media (max-width: 600px) {
    height: 100lvh;
  }
`;

export const InnerPopup = styled.div`
  padding: 32px;
  width: 100%;
  max-width: 640px;
  max-height: 90vh;
  background-color: #8dabe2;
  color: #ffffff;
  border-radius: 10px;
  box-shadow: 12px 12px 2px 1px rgba(255, 255, 255, 0.2);
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  @media (max-width: 600px) {
    height: 100lvh;
    max-height: 100lvh;
    padding: 2%;
  }
`;

export const Indent = styled.div`
  padding-left: 20px; /* Indent by 20px */
`;

export const CloseButton = styled(Button)`
  margin-top: 30px;
  width: auto;
  height: auto;
  white-space: nowrap;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  flex-wrap: wrap;
  gap: 4px;
`;

export const Label = styled.span`
  white-space: nowrap;
  flex-shrink: 0;
`;

export const Dots = styled.span`
  flex-grow: 1;
  border-bottom: 1px dotted #ccc;
  margin: 0 8px;
  min-width: 20px;
`;

export const Value = styled.span`
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
  display: inline-block;
  padding-left: 20px;
  text-indent: -20px;

  /* Ensure wrapped lines are properly indented */
  & > * {
    text-indent: 0;
  }
`;

// Toggle Switch Components
export const ToggleContainer = styled.label`
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
  cursor: pointer;
`;

export const ToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + span {
    background-color: #5577aa;
  }

  &:checked + span:before {
    transform: translateX(30px);
    background-color: #ffffff;
  }

  &:checked + span:after {
    content: "On";
    left: 8px;
    color: #ffffff;
  }

  &:focus + span {
    box-shadow: 0 0 1px #5577aa;
  }
`;

export const ToggleSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ffffff;
  transition: 0.4s;
  border-radius: 30px;
  border: 1px solid #ccc;

  &:before {
    position: absolute;
    content: "";
    height: 22px;
    width: 22px;
    left: 4px;
    bottom: 4px;
    background-color: #5577aa;
    transition: 0.4s;
    border-radius: 50%;
    z-index: 2;
  }

  &:after {
    position: absolute;
    content: "Off";
    color: #5577aa;
    font-size: 11px;
    font-weight: bold;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    transition: 0.4s;
    z-index: 1;
  }
`;